import { render } from "./MainExpansionPanel.vue?vue&type=template&id=9ddf3a78"
import script from "./MainExpansionPanel.vue?vue&type=script&lang=js"
export * from "./MainExpansionPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__